import { clsx } from 'clsx';

/** Elegant placeholder when a product has no photo yet. */
export function ProductThumb({
  src,
  alt,
  className,
  label,
}: {
  src?: string | null;
  alt: string;
  className?: string;
  label?: string | null;
}) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={clsx('h-full w-full object-cover', className)}
      />
    );
  }
  return (
    <div
      className={clsx(
        'flex h-full w-full flex-col items-center justify-center bg-gradient-to-br from-gold-50 to-ink-50 text-gold-400',
        className,
      )}
    >
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
        <path d="M12 3l3 4 6 1-4 4 1 6-6-3-6 3 1-6-4-4 6-1z" strokeLinejoin="round" />
      </svg>
      {label && <span className="mt-1 px-2 text-center text-[10px] uppercase tracking-wide">{label}</span>}
    </div>
  );
}
